import { SET_BOOKING_SOURCE, SET_BOOKING_SOURCES, SET_BOOKING_SOURCE_FILTERS } from '@/store/mutation_types'

export default {
  [SET_BOOKING_SOURCE](state, value) {
    state.bookingSource = value
  },
  [SET_BOOKING_SOURCES](state, value) {
    state.bookingSources = value
  },
  SET_BOOKING_SOURCES(state, value) {
    state.bookingSources = value
  },
  [SET_BOOKING_SOURCE_FILTERS](state, value) {
    state.bookingSourceFilters = value
  },
}
